module.exports = __webpack_public_path__ + "img/header-memoireRingsBestseller.5c50412.webp";